// Temporarily using the Image16 icon until the creative library navigation icon gets designed

import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const CreativeLibrary = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 16 16"
    className="shape"
    {...props}
  >
    <g>
      <path
        fill={getColor(color, isColorInherited)}
        d="M12.875,1.875h-9.75c-0.69037,0-1.25,0.55963-1.25,1.25v7.5v2.25c0,0.69031,0.55963,1.25,1.25,1.25h9.75
        c0.69043,0,1.25-0.55969,1.25-1.25v-2.25v-7.5C14.125,2.43463,13.56543,1.875,12.875,1.875z M13.125,12.875
        c0,0.13812-0.11188,0.25-0.25,0.25h-9.75c-0.13806,0-0.25-0.11188-0.25-0.25v-1.75h1.7442c0.00366,0,0.00726,0,0.01086,0H13.125
        V12.875z M13.125,10.125h-7.5l1.1311-1.50812C6.77759,8.5882,6.80499,8.56451,6.83649,8.5473
        c0.03143-0.01715,0.06622-0.02734,0.10193-0.02985c0.03571-0.00256,0.07159,0.00262,0.10516,0.01514S7.10767,8.5647,7.133,8.59003
        l0.51349,0.51355c0.10248,0.10242,0.24438,0.15546,0.38898,0.14514s0.27759-0.08276,0.36456-0.19873l1.64996-2.20001
        c0.02332-0.03101,0.05353-0.05621,0.0882-0.07361C10.17291,6.75903,10.21118,6.75,10.25,6.75s0.07709,0.00903,0.11182,0.02637
        c0.03467,0.0174,0.06488,0.0426,0.0882,0.07361L11.78497,8.63c0.16571,0.22089,0.47913,0.26569,0.70001,0.09998
        c0.22089-0.16565,0.26569-0.47906,0.10004-0.70001L11.25,6.25c-0.11639-0.15521-0.2674-0.28125-0.44098-0.36804
        C10.6355,5.79517,10.44409,5.75,10.25,5.75c-0.19397,0-0.38544,0.04517-0.55896,0.13196C9.51746,5.96875,9.36646,6.09479,9.25,6.25
        L7.94592,7.98877L7.84009,7.88293C7.71344,7.75629,7.56104,7.65833,7.39325,7.5957C7.2254,7.53308,7.04608,7.50726,6.86737,7.51996
        C6.68872,7.53271,6.51483,7.58368,6.3576,7.66943S6.06335,7.87384,5.95593,8.01715L4.375,10.125h-1.5v-7
        c0-0.13806,0.11194-0.25,0.25-0.25h9.75c0.13812,0,0.25,0.11194,0.25,0.25V10.125z"
      />
      <path
        fill={getColor(color, isColorInherited)}
        d="M5.1875,3.75C4.39362,3.75,3.75,4.39362,3.75,5.1875S4.39362,6.625,5.1875,6.625
        S6.625,5.98138,6.625,5.1875S5.98138,3.75,5.1875,3.75z M5.1875,5.625C4.94586,5.625,4.75,5.42914,4.75,5.1875
        S4.94586,4.75,5.1875,4.75S5.625,4.94586,5.625,5.1875S5.42914,5.625,5.1875,5.625z"
      />
    </g>
  </SvgIcon>
);
